const MOBILE_QUERY = '(max-width: 749px)';

function normalizeMenuTitle(value = '') {
  return value
    .trim()
    .toLowerCase()
    .replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getInsertBlocks() {
  return Array.from(document.querySelectorAll('[data-menu-insert]')).filter(
    (element) => element instanceof HTMLElement
  );
}

function findDesktopSubmenuTarget(targetHandle) {
  if (!targetHandle) return null;

  const menuItems = document.querySelectorAll('header-menu .menu-list__list-item:not([slot])');

  for (const item of menuItems) {
    const title = item.querySelector(':scope > .menu-list__link .menu-list__link-title');
    if (!title) continue;

    if (normalizeMenuTitle(title.textContent || '') !== targetHandle) continue;

    return item.querySelector('.mega-menu__grid') || item.querySelector('.menu-list__submenu-inner');
  }

  return null;
}

function getMobileDrawer() {
  return document.querySelector('header-drawer .menu-drawer');
}

function getOrCreateMobileRoot() {
  const drawer = getMobileDrawer();
  if (!(drawer instanceof HTMLElement)) return null;

  let root = drawer.querySelector('[data-menu-custom-mobile-root]');
  if (root instanceof HTMLElement) return root;

  const navigation = drawer.querySelector('.menu-drawer__navigation');
  if (!(navigation instanceof HTMLElement)) return null;

  root = document.createElement('div');
  root.className = 'menu-drawer__custom-content-root';
  root.dataset.menuCustomMobileRoot = '';
  navigation.append(root);

  return root;
}

function createSubmenuTarget(container) {
  let customTarget = container.querySelector(':scope > .menu-drawer__custom-submenu-content');

  if (!(customTarget instanceof HTMLElement)) {
    customTarget = document.createElement('div');
    customTarget.className = 'menu-drawer__custom-submenu-content';
    container.append(customTarget);
  }

  return customTarget;
}

function findMobileSubmenuTarget(targetHandle) {
  const drawer = getMobileDrawer();
  if (!(drawer instanceof HTMLElement) || !targetHandle) return null;

  const triggers = drawer.querySelectorAll('[id^="HeaderDrawer-"]');
  let trigger = null;

  for (const candidate of triggers) {
    if (!(candidate instanceof HTMLElement)) continue;
    const title = candidate.querySelector('.menu-drawer__menu-item-text')?.textContent || candidate.textContent || '';
    if (normalizeMenuTitle(title) === targetHandle) {
      trigger = candidate;
      break;
    }
  }

  if (!(trigger instanceof HTMLElement)) return null;

  const details = trigger.closest('details');
  if (details instanceof HTMLDetailsElement) {
    const innerSubmenu = details.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu');
    if (innerSubmenu instanceof HTMLElement) return createSubmenuTarget(innerSubmenu);

    return createSubmenuTarget(details);
  }

  const listItem = trigger.closest('li');
  if (listItem instanceof HTMLElement) return createSubmenuTarget(listItem);

  return null;
}

function placeDesktopInsert(insert) {
  const desktopEnabled = insert.dataset.desktopEnabled === 'true';

  insert.classList.remove('menu-insert--mobile');
  insert.classList.toggle('menu-insert--desktop', desktopEnabled);

  if (!desktopEnabled) {
    insert.hidden = true;
    return;
  }

  const target = findDesktopSubmenuTarget(insert.dataset.desktopTarget || '');
  if (!(target instanceof HTMLElement)) {
    insert.hidden = true;
    return;
  }

  if (insert.parentElement !== target) target.append(insert);
  insert.hidden = false;
}

function placeMobileInsert(insert) {
  const mobileEnabled = insert.dataset.mobileEnabled === 'true';

  insert.classList.remove('menu-insert--desktop');
  insert.classList.toggle('menu-insert--mobile', mobileEnabled);

  if (!mobileEnabled) {
    insert.hidden = true;
    return;
  }

  let target = null;

  if (insert.dataset.mobilePlacement === 'target_submenu') {
    target = findMobileSubmenuTarget(insert.dataset.mobileTarget || '');
  }

  if (!(target instanceof HTMLElement)) {
    target = getOrCreateMobileRoot();
  }

  if (!(target instanceof HTMLElement)) {
    insert.hidden = true;
    return;
  }

  if (insert.parentElement !== target) target.append(insert);
  insert.hidden = false;
}

function placeMenuContent() {
  const isMobile = window.matchMedia(MOBILE_QUERY).matches;

  for (const insert of getInsertBlocks()) {
    if (isMobile) {
      placeMobileInsert(insert);
    } else {
      placeDesktopInsert(insert);
    }
  }
}

let queuedFrame = null;

function queuePlacement() {
  if (queuedFrame !== null) cancelAnimationFrame(queuedFrame);

  queuedFrame = requestAnimationFrame(() => {
    queuedFrame = null;
    placeMenuContent();
  });
}

const mediaQuery = window.matchMedia(MOBILE_QUERY);
mediaQuery.addEventListener('change', queuePlacement);

window.addEventListener('DOMContentLoaded', queuePlacement, { once: true });
document.addEventListener('shopify:section:load', queuePlacement);
document.addEventListener('shopify:block:select', queuePlacement);
document.addEventListener('shopify:block:deselect', queuePlacement);

if (document.readyState !== 'loading') queuePlacement();
